import { createContext } from 'react';

import { LegendItem } from '../../../../core/components/legend/categorical/types/legend.js';
import type { HoneycombLabelsDisplay } from '../../../types/honeycomb.js';

export type DisplayConfigProps = {
  hovered?: LegendItem | undefined;
  labelsDisplay?: HoneycombLabelsDisplay;
};

export const DisplayConfigContext = createContext<DisplayConfigProps>({});

DisplayConfigContext['displayName'] = 'DisplayConfigContext';
